export default __webpack_public_path__ + "media/images/brands/joseph-joseph-7cff37aa7e7cb568ea4896af5003706e.png";